import {
  type UnitLabelType,
  type UnitsListItem,
  type UnitsResponse,
} from './types';

type FilterFunction = (entry: [string, UnitsListItem]) => boolean;

/**
 * Select function for returning options for a select component from the units query response.
 *
 * @param data - The UnitsResponse object containing unit definitions.
 * @param label - The property of UnitsListItem to use as the option label ('fullName', 'abbreviation', or 'combined'). Defaults to 'fullName'.
 * @param filterFunction - Optional filter function to include/exclude units. Receives [uncefactUnit, unitDefinition]. Defaults to including all units.
 * @returns Array of options: { label, value, data }
 */
export const mapUnitOptions = (
  data: UnitsResponse,
  label: UnitLabelType | 'combined' = 'fullName',
  filterFunction: FilterFunction = () => true,
) =>
  Object.entries(data.units)
    .filter(filterFunction)
    .map(([uncefactUnit, unitDefinition]) => ({
      label:
        label === 'combined'
          ? `${unitDefinition.fullName} (${uncefactUnit.toUpperCase()})`
          : unitDefinition[label],
      value: uncefactUnit.toUpperCase(),
      data: unitDefinition,
    }));
